import React, { Component } from 'react';
import { Card, CardBody, Col, Button, ButtonGroup } from 'reactstrap';
import { Blogs } from '../../../services/Blogs';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { deleteBlog, fetchBlogs } from '../../../redux/actions/blogsActions';
import { isDirty, reduxForm} from 'redux-form'
import {withTranslation} from "react-i18next";
import Notifications from '../../../hof/notifications';

class ManageBlog extends Component {

  constructor() {
    super();
    this.state = {
      clickToDelete: 5,
    }
  }

  deleteBlogWithId = async (id) => {
    const {clickToDelete} = this.state;
    const {t} = this.props;

    if(clickToDelete > 1) {
      this.setState({clickToDelete: clickToDelete - 1});
    } else {
      console.log(id);
      const response = await Blogs.deleteBlog(id);
      this.setState({clickToDelete: 5});
      console.log(response);
      this.props.onDeleteBlog(id);
      this.props.onFetchBlogs();
      Notifications.showNotification(
          t('settings.manage_blog.notifications.blog_deleted.title'),
          t('settings.manage_blog.notifications.blog_deleted.body'),
          Notifications.Colors.SUCCESS);
      this.props.history.push('/');
    }
  }

  render() {

    const {t} = this.props;

    const { handleSubmit, handleSaveSettings } = this.props;
    return (
      <Col md={12} lg={12} xl={12}>
        <Card className="card--not-full-height">
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('settings.manage_blog.title')}</h5>
              <h5 className="subhead">{t('settings.manage_blog.subtitle')}</h5>
            </div>
            <div className="card__body" >
              <ButtonGroup className="btn-group--justified" >
                <Button size="sm" outline color="danger" onClick={ async () => { await this.deleteBlogWithId(this.props.blogId)} } >
                  { this.state.clickToDelete === 5
                    ? t('settings.manage_blog.button_delete_blog')
                    : `${t('settings.manage_blog.button_clicks_to_delete')}: ${this.state.clickToDelete}`
                  }
                </Button>
              </ButtonGroup>
              {this.props.isDirty && <ButtonGroup className="btn-group--justified" >
                <Button size="sm" color="success" onClick={handleSubmit(handleSaveSettings)}>
                  {t('settings.manage_blog.button_save_settings')}
                </Button>
              </ButtonGroup>}
              {this.props.error && <span className="form__form-group-error">{t('settings.manage_blog.saving_error')}</span>}
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    isDirty: isDirty('blog_settings')(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onDeleteBlog: (id) => dispatch(deleteBlog(id)),
    onFetchBlogs: () => dispatch(fetchBlogs())
  }
}

ManageBlog = withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageBlog));

export default reduxForm({
  form: 'blog_settings'
})(withTranslation('dashboard')(ManageBlog));
